import { WSElement, WSIcon, WSText } from "@wingspanhq/fe-component-library";
import styles from "./index.module.scss";

type Props = {
  title: string;
  onClose?: () => void;
};

export const Layout: React.FC<Props> = ({ title, onClose, children }) => (
  <WSElement className={styles.layout}>
    <WSElement className={styles.header}>
      <WSText.ParagraphSm my="L" weight="medium">
        {title}
      </WSText.ParagraphSm>
      {onClose && (
        <WSIcon onClick={onClose} className={styles.closeIcon} name="exit" />
      )}
    </WSElement>
    <WSElement className={styles.content}>{children}</WSElement>
  </WSElement>
);
